import axios from "axios";
import { atualUfDefinition, EnumAmbienteTipos } from "../../../helpers/utils";

function isLocalhost() {
  const currentHost = window.location.hostname || "";
  return currentHost === "localhost" || currentHost === "127.0.0.1";
}

function resolveBaseUrl() {
  if (isLocalhost()) {
    return process.env.VUE_APP_BASE_API_LOCAL || "http://localhost:64332/";
  }
  if (atualUfDefinition && atualUfDefinition.env) return atualUfDefinition.env;
  return process.env.VUE_APP_BASE_API_CE_HLG || "";
}

function resolveBanco() {
  const params = new URLSearchParams(window.location.search || "");
  const bancoParam = params.get("banco");
  if (bancoParam) return bancoParam;
  if (atualUfDefinition && atualUfDefinition.banco) return atualUfDefinition.banco;
  return isLocalhost() ? "ce-sc-hlg" : "";
}

function resolveBranch() {
  const params = new URLSearchParams(window.location.search || "");
  const branchParam = params.get("branch");
  if (branchParam) return branchParam;
  if (atualUfDefinition && atualUfDefinition.ambient === EnumAmbienteTipos.prod) return "main";
  return "hlg";
}

const api = axios.create({ baseURL: resolveBaseUrl() });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  config.headers = config.headers || {};
  config.headers.banco = resolveBanco();
  config.headers.branch = resolveBranch();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const analiseRelatoriosIaApi = {
  async obterPainel(params) {
    const cleanParams = {};
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value !== null && value !== undefined && value !== "") {
        cleanParams[key] = value;
      }
    });
    const { data } = await api.get("/api/IaAnaliseRelatorios/painel", { params: cleanParams });
    return data;
  },
  async obterOpcoes(params) {
    const cleanParams = {};
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value !== null && value !== undefined && value !== "") {
        cleanParams[key] = value;
      }
    });
    const { data } = await api.get("/api/IaAnaliseRelatorios/opcoes", { params: cleanParams });
    return data;
  },
  async criarExecucao(payload) {
    const { data } = await api.post("/api/IaAnaliseRelatorios/execucoes", payload);
    return data;
  },
  async registrarDecisao(id, payload) {
    const { data } = await api.post(`/api/IaAnaliseRelatorios/itens/${encodeURIComponent(id)}/decisao`, payload);
    return data;
  },
  async sincronizarDecisoes(payload) {
    const { data } = await api.post("/api/IaAnaliseRelatorios/sincronizar", payload);
    return data;
  },
  async atualizarRegrasHistorico(payload) {
    const { data } = await api.post("/api/IaAnaliseRelatorios/regras/atualizar-historico", payload);
    return data;
  },
  async listarRegras(params) {
    const cleanParams = {};
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value !== null && value !== undefined && value !== "") {
        cleanParams[key] = value;
      }
    });
    const { data } = await api.get("/api/IaAnaliseRelatorios/regras", { params: cleanParams });
    return data;
  },
  async salvarRegra(payload) {
    const id = payload && payload.analiseRelatoriosIaRegraId;
    if (id) {
      const { data } = await api.put(`/api/IaAnaliseRelatorios/regras/${encodeURIComponent(id)}`, payload);
      return data;
    }
    const { data } = await api.post("/api/IaAnaliseRelatorios/regras", payload);
    return data;
  },
  async desativarRegra(id) {
    const { data } = await api.post(`/api/IaAnaliseRelatorios/regras/${encodeURIComponent(id)}/desativar`);
    return data;
  },
  async analisarRascunho(payload, anexos = []) {
    const formData = new FormData();
    Object.keys(payload || {}).forEach((chave) => {
      const valor = payload[chave];
      if (valor !== null && valor !== undefined) {
        formData.append(chave, valor);
      }
    });
    anexos.forEach((arquivo) => formData.append("anexos", arquivo, arquivo.name));
    const { data } = await api.post("/api/IaAnaliseRelatorios/rascunho", formData, {
      timeout: 180000,
    });
    return data;
  },
  async baixarAnexo(relatorioAnexoId) {
    const { data } = await api.get(`/api/arquivo/anexo/download/${encodeURIComponent(relatorioAnexoId)}`, {
      responseType: "blob",
    });
    return data;
  },
};
